import { Box, Skeleton, Breadcrumbs } from '@mui/material';

export const MemberBreadcrumbsSkeleton = () => {
  return (
    <Breadcrumbs sx={{ mb: 2 }}>
      <Box display="flex" alignItems="center" gap={1}>
        <Skeleton variant="text" width={100} height={20} />
      </Box>
      <Skeleton variant="text" width={80} height={20} />
      <Skeleton variant="text" width={120} height={20} />
    </Breadcrumbs>
  );
};
